"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBlock = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const BlockText_1 = require("./BlockText");
const nano_theme_1 = require("nano-theme");
const CodeblockLayout_1 = require("../CodeblockLayout");
const Split_1 = require("../../3-list-item/Split");
const CopyButton_1 = require("../../2-inline-block/CopyButton");
const css = {
    block: (0, nano_theme_1.rule)({
        pd: 0,
        mr: 0,
        pre: {
            mr: 0,
        },
    }),
};
const TextBlock = ({ src, header, compact, select, lang }) => {
    return (React.createElement("div", { className: css.block },
        React.createElement(CodeblockLayout_1.CodeblockLayout, null,
            React.createElement(Split_1.Split, null,
                React.createElement("div", null, header),
                React.createElement(CopyButton_1.CopyButton, { onCopy: () => src })),
            React.createElement("div", { style: { paddingRight: 24 } },
                React.createElement("div", { style: { margin: compact ? '-24px 0 -4px' : '-20px 0 0', maxWidth: '100%', overflowX: 'auto' } },
                    React.createElement(BlockText_1.BlockText, { src: src, compact: compact, select: select, lang: lang }))))));
};
exports.TextBlock = TextBlock;
